
import { USER } from "../constant/actionTypes";

export default (state, action) => {
    if (typeof state == 'undefined') {
        state = [];
    }

    switch (action.type) {
        case USER.DATA.INITIATE:
            return {isFetching: false};
        case USER.DATA.SUCCESS:
            return {isFetching: true, data: action.payload};
        case USER.DATA.ERROR:
            return {isFetching: true, data: action.payload};
        default:
            return state;
    }
};
